import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Protected } from "@/components/Protected";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import FlyerStudio from "@/pages/FlyerStudio";
import VideoStudio from "@/pages/VideoStudio";
import VoiceStudio from "@/pages/VoiceStudio";
import MusicStudio from "@/pages/MusicStudio";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Composer from "@/pages/Composer";
import VideoSequenceStudio from "@/pages/VideoSequenceStudio";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import BriefSubmit from "@/pages/BriefSubmit";
import BriefTrack from "@/pages/BriefTrack";
import AgencyDashboard from "@/pages/AgencyDashboard";
import Legal from "@/pages/Legal";
import AdminStats from "@/pages/AdminStats";
import AssistantWidget from "@/components/AssistantWidget";
import ExitIntentModal from "@/components/ExitIntentModal";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Handle Emergent OAuth callback synchronously during render to prevent race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/brief/:agency_id" element={<BriefSubmit />} />
      <Route path="/brief/track/:token" element={<BriefTrack />} />
      <Route path="/legal" element={<Legal />} />
      <Route path="/legal/:section" element={<Legal />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/studio/flyer" element={<Protected><FlyerStudio /></Protected>} />
      <Route path="/studio/video" element={<Protected><VideoStudio /></Protected>} />
      <Route path="/studio/sequence" element={<Protected><VideoSequenceStudio /></Protected>} />
      <Route path="/studio/voice" element={<Protected><VoiceStudio /></Protected>} />
      <Route path="/studio/music" element={<Protected><MusicStudio /></Protected>} />
      <Route path="/studio/composer" element={<Protected><Composer /></Protected>} />
      <Route path="/studio/agency" element={<Protected><AgencyDashboard /></Protected>} />
      <Route path="/admin/stats" element={<Protected><AdminStats /></Protected>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <main className="min-h-[calc(100vh-4rem)]">
            <AppRouter />
          </main>
          <AssistantWidget />
          <ExitIntentModal />
          <Footer />
          <Toaster theme="dark" position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
